<template>
  <b-field>
    <b-taginput
      v-model="val"
      icon="label"
      ellipsis
      open-on-focus
      autocomplete
      :placeholder="schema.title"
      :data="filteredExamples"
      :allow-new="false"
      @typing="onTyping"
      @add="onSuggestionAdded"
    ></b-taginput>
  </b-field>
</template>

<script>
import SchemaFormElementMixin from '@/mixins/SchemaFormElementMixin'

export default {
  name: 'SchemaFormElementTaginput',
  mixins: [SchemaFormElementMixin],
  data() {
    return {
      filteredExamples: this.schema.examples
    }
  },
  methods: {
    onTyping(text) {
      if (!text) {
        this.filteredExamples = this.schema.examples
      }

      this.filteredExamples = this.schema.examples.filter(
        example => example.toLowerCase().includes(text.toLowerCase()) && !this.val.includes(example)
      )
    },
    onSuggestionAdded() {
      this.filteredExamples = this.schema.examples.filter(example => !this.val.includes(example))
    }
  },
  created() {
    if (Array.isArray(this.schema.default) && !this.val && !this.value) {
      this.val = this.schema.default
    }
  }
}
</script>
